import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import axios from 'axios';

export default {
    ObtenerReportesAbogado(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerReportesAbogado`).then(response => response.data);
    },
    InsertaEnvioPago(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/InsertaEnvioPago`, data).then(response => response.data);
    },
    InsertaReportesPago(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/InsertaReportesPago`, data).then(response => response.data);
    },
    ObtenerPerfil(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerPerfil`).then(response => response.data);
    },
    DocumentacionPendiente(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/DocumentacionPendiente`).then(response => response.data);
    },
    GuardaRecepcionDocto(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/GuardaRecepcionDocto`, data).then(response => response.data);
    },
    ObtenerReportesFactura(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerReportesFactura`).then(response => response.data);
    },
    ReportePendienteEntrega(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ReportePendienteEntrega`).then(response => response.data);
    },
    CatalogoPaqueteria(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/CatalogoPaqueteria`).then(response => response.data);
    },
    ReportesEnviados(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ReportesEnviados`, data).then(response => response.data);
    },
    ObtenerUsuario(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerUsuario`, data).then(response => response.data);
    },
    GuardarEnvioDocto(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/GuardarEnvioDocto`, data)
            .then(response => response.data);
    },
    RecibirDocumentos(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/RecibirDocumentos`, data).then(response => response.data);
    },
    ReportesPendienteValidar(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ReportesPendienteValidar`, data).then(response => response.data);
    },
    GuardarRecibirDocto(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/GuardarRecibirDocto`, data).then(response => response.data);
    },
    GuardarValidarReporte(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/GuardarValidarReporte`, data).then(response => response.data);
    },
    ProcesarPago(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ProcesarPago`, data).then(response => response.data);
    },
    RechazarPago(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/RechazarPago`, data).then(response => response.data);
    },
    ObtenerDatosReporte(vm, data){
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerDatosReporte`, data).then(response => response.data);
    },
    ConceptoPago(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ConceptoPago`, data).then(response => response.data);
    },
    MotivoCancelar(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/MotivoCancelar`).then(response => response.data);
    },
    LineaTiempo(vm, data){
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/LineaTiempo`, data).then(response => response.data);
    },
    LineaTiempoEstado(vm, data){
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/LineaTiempoEstado`, data).then(response => response.data);
    },
    ObtenerFecha(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerFecha`, data).then(response => response.data);
    },
    EnviarFactura(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/EnviarFactura`)
            .then(response => response.data);
    },
    GuardarEnvioFactura(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/GuardarEnvioFactura`, data)
            .then(response => response.data);
    },
    ObtenerRegistroContrarecibo(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerRegistroContrarecibo`)
            .then(response => response.data)
            .catch(error => {
                console.log(error.response, 'Error')
            });
    },
    ObtenerReporteContrarecibo(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerReporteContrarecibo`, data)
            .then(response => response.data)
            .catch(error => {
                console.log(error.response, 'Error')
            });
    },
    ValidarPagoFactura(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidarPagoFactura`, data)
            .then(response => response.data);
    },
    ObtenerFacturaArchivo(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerFacturaArchivo`, data)
            .then(response => response.data);
    },
    VerificarTramitePago(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/VerificarTramitePago`, data).then(response => response.data);
    },
    CentroCosto(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/CentroCosto`).then(response => response.data);
    },
    ObtenerNivel1(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerNivel1`).then(response => response.data);
    },
    ObtenerNivel2(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerNivel2`, data).then(response => response.data);
    },
    ObtenerNivel3(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerNivel3`, data).then(response => response.data);
    },
    ObtenerNivel4(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerNivel4`, data).then(response => response.data);
    },
    ObtenerNivel5(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerNivel5`, data).then(response => response.data);
    },
    ValidarFactura(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidarFactura`, data)
            .then(response => response.data);
    },
    ObtenerDatosProveedor(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerDatosProveedor`, data).then(response => response.data);
    },
    ValidaFirmaElectronica(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidaFirmaElectronica`, data).then(response => response.data);
    },
    ObtenerCCProveedor(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerCCProveedor`, data).then(response => response.data);
    },
    async ValidarContrarecibo(vm, data) {
        let respuesta = await vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidarContrarecibo`, data);
        return respuesta.data;
    },
    ValidarGnp(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidarGnp`, data, { timeout: 1000000 }).then(response => response.data);
    },
    CargarGnp(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/CargarGnp`, data).then(response => response.data);
    },
    ObtenerProveedor(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerProveedor`).then(response => response.data);
    },
    TipoViaticos(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/TipoViaticos`).then(response => response.data);
    },
    ObtenerGtidConcepto(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerGtidConcepto`, data).then(response => response.data);
    },
    ValidaDuplicado(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidaDuplicado`, data).then(response => response.data);
    },
    ValidaViaticos(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidaViaticos`, data).then(response => response.data);
    },
    ValidaComprobante(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidaComprobante`, data).then(response => response.data);
    },
    ObtenerAutorizar(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtenerAutorizar`, data).then(response => response.data);
    },
    VerificaFirma(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/VerificaFirma`, data).then(response => response.data);
    },
    PagoSubConcepto(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/PagoSubConcepto`, data).then(response => response.data);
    },
    PagoDatosReporte(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/PagoDatosReporte`, data).then(response => response.data);
    },
    SubConcepto(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/SubConcepto`, data).then(response => response.data);
    },
    ObtenerRouterNameaiclave(data) {
        let name = '';
        switch (data) {
            case "1":
                name = `GarantiasExpJur`;
                break;
            case "24":
                name = `GarantiasRobo`;
                break;
            case "23":
                name = `GarantiasRLV`;
                break;
            case "5":
                name = `GarantiasRCMedico`;
                break;
        }

        return name;
    },
    GuardarPreSolicitud(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/GuardarPreSolicitud`, data).then(response => response.data);
    },
    CuentaProveedor(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/CuentaProveedor`, data).then(response => response.data);
    },
    DatosReportePago(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/DatosReportePago`, data).then(response => response.data);
    },
    HistorialPago(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/HistorialPago`, data).then(response => response.data);
    },
    ReportesmismoMP(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ReportesmismoMP`, data).then(response => response.data);
    },

    DatosGenerales(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/DatosGenerales`, data).then(response => response.data);
    },
    Partidas(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/Partidas`, data).then(response => response.data);
    },
    GuardaAutorizacion(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/GuardaAutorizacion`, data).then(response => response.data);
    },
    ValidacionPartidas(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ValidacionPartidas`, data).then(response => response.data);
    },
    async ObtieneDatosReporte(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        var datosReporte = new FormData();
        datosReporte.append("reporte", datos.nrreporte);
        datosReporte.append("indice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}TramitePago/ObtieneDatosReporte`, datosReporte).then(response => response.data);
    },
}